import React, { useEffect, useContext, useState } from 'react';  
import {useNavigate, useParams} from "react-router-dom";
import Axios from "axios"
import AxiosInstance from "../../AxiosInstance";
import { useImmerReducer } from 'use-immer';
import {
    Grid, Typography, IconButton, Card, CardMedia, CardContent, 
    CircularProgress, CardActions, Container, Box, Button, Divider, 
    Avatar, TextField, Snackbar, Alert, Paper, Autocomplete, Chip
} from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';

import StateContext from "../../Contexts/StateContext";
//Assets
import defaultProfilePicture from "../../Assets/defaultProfilePicture.jpg";
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChatIcon from '@mui/icons-material/Chat';
import StarIcon from '@mui/icons-material/Star';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';

const defaultIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

function CompanyDetail() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const GlobalState = useContext(StateContext)  
    const {config, environment } = require('../../index');

    const params = useParams();
    const { i18n } = useTranslation();
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [openSnack, setOpenSnack] = useState(false);
    const [bookingStatus, setBookingStatus] = useState('success');
    const [allCompanies, setAllCompanies] = useState([]);
    const [linkCompanyId, setLinkCompanyId] = useState(null);
    const [companyData, setCompanyData] = useState(null);
    
    const initialState = {       
        userProfile:{
            id: null,
            companyName: '',
            phoneNumber: '',
            profilePic: '',
            bio: '',
            sellerListings: [],
            facebookUrl: '',
            is_recommended: false,
            recommender_name: '',
            linked_master_details: null,
            email: '',
            latitude: null,
            longitude: null,
            address: '',
            szek: '',
            kozsegvaros: '',
            telepules: '',
            website: ''
        }, 
        dataIsLoading: true,       
    };

    function ReducerFunction(draft, action){
        switch(action.type){
            case 'catchUserProfileInfo':
                draft.userProfile.id = action.profileObject.id;
                draft.userProfile.companyName = action.profileObject.name; 
                draft.userProfile.phoneNumber = action.profileObject.phone_number;
                draft.userProfile.profilePic = action.profileObject.picture;
                draft.userProfile.bio = action.profileObject.description;
                draft.userProfile.facebookUrl = action.profileObject.facebook_url;
                draft.userProfile.availabilities = action.profileObject.availabilities;
                draft.userProfile.is_recommended = action.profileObject.is_recommended;
                draft.userProfile.recommender_name = action.profileObject.recommender_name;
                draft.userProfile.linked_master_details = action.profileObject.linked_master_details;
                draft.userProfile.email = action.profileObject.email;
                draft.userProfile.latitude = action.profileObject.latitude;
                draft.userProfile.longitude = action.profileObject.longitude;
                draft.userProfile.address = action.profileObject.address;
                draft.userProfile.szek = action.profileObject.szek;
                draft.userProfile.kozsegvaros = action.profileObject.kozsegvaros;
                draft.userProfile.telepules = action.profileObject.telepules;
                draft.userProfile.website = action.profileObject.website;
                 break;
            case 'loadingDone': 
                draft.dataIsLoading = false;
                break;           
        }
    }

    const [state, dispatch] = useImmerReducer(ReducerFunction, initialState)  

    //request to get profie info
    useEffect(() => {
        async function getProfileInfo() {
            try {   
                const response = await AxiosInstance.get(`${config[environment].businessesEndpoint}${params.id}/`);
                setCompanyData(response.data);
                dispatch({type: 'catchUserProfileInfo', profileObject: response.data});
                
                // Fetch all registered companies for linking
                const allRes = await AxiosInstance.get(`${config[environment].businessesEndpoint}?type=Company`);
                setAllCompanies(allRes.data.filter(c => !c.is_recommended && c.id !== parseInt(params.id)));
                
                dispatch({type: 'loadingDone'});
            } catch (e) {
            }
        }
        getProfileInfo();
    }, [params.id, config, environment]);

    const handleLinkCompany = async () => {
        try {
            await AxiosInstance.patch(`${config[environment].businessesEndpoint}${params.id}/`, {
                linked_master: linkCompanyId
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setBookingStatus('success');
            setOpenSnack(true);
            // Refresh
            const response = await AxiosInstance.get(`${config[environment].businessesEndpoint}${params.id}/`);
            dispatch({type: 'catchUserProfileInfo', profileObject: response.data});
        } catch (error) {
            setBookingStatus('error');
            setOpenSnack(true);
        }
    };

    const handleBooking = async () => {
        try {
            await AxiosInstance.post(config[environment].businessBookingsEndpoint, {
                business: params.id,
                date: selectedDate.format('YYYY-MM-DD'),
                message: "Foglalás a weboldalról"
            }, {
                headers: {
                    Authorization: `Bearer ${GlobalState.jwtAccessToken}`
                }
            });
            setBookingStatus('success');
            setOpenSnack(true);
        } catch (error) {
            setBookingStatus('error');
            setOpenSnack(true);
        }
    };

    const handleDelete = async () => {
        if (window.confirm(t('Common.DeleteConfirm'))) {
            try {
                try {
                    await AxiosInstance.delete(`${config[environment].businessesEndpoint}${params.id}/delete/`);
                } catch (delErr) {
                    if (delErr.response && (delErr.response.status === 405 || delErr.response.status === 404)) {
                        await AxiosInstance.delete(`${config[environment].businessesEndpoint}${params.id}/`);
                    } else {
                        throw delErr;
                    }
                }
                setBookingStatus('success');
                setOpenSnack(true);
                setTimeout(() => {
                    if (companyData.business_type === 'Master') {
                        navigate(`/${i18n.language}/mesterek`);
                    } else if (companyData.business_type === 'DayLabourer') {
                        navigate(`/${i18n.language}/napszamosok`);
                    } else {
                        navigate(`/${i18n.language}/cegek`);
                    }
                }, 2000);
            } catch (error) {
                setBookingStatus('error');
                setOpenSnack(true);
            }
        }
    };

    if(state.dataIsLoading === true){
        return (<Grid container justifyContent="center" alignItems="center" style={{height:"100vh"}}>
          <CircularProgress/>
        </Grid>);
    }

    const whatsappUrl = state.userProfile.phoneNumber ? `https://wa.me/${state.userProfile.phoneNumber.replace(/\D/g, '')}` : null;
    const messengerUrl = state.userProfile.facebookUrl ? state.userProfile.facebookUrl.replace('facebook.com', 'm.me') : null;

    const isOwner = companyData && GlobalState.userId && parseInt(companyData.owner) === parseInt(GlobalState.userId);

    const editPath = companyData ? (
        companyData.business_type === 'Master' ? `/${i18n.language}/mester/szerkesztes/${params.id}` :
        companyData.business_type === 'Company' ? `/${i18n.language}/ceg/szerkesztes/${params.id}` :
        `/${i18n.language}/napszamos/szerkesztes/${params.id}`
    ) : `/${i18n.language}/ceg/szerkesztes/${params.id}`;

    const shouldDisableDate = (date) => {
        if (!state.userProfile.availabilities) return false;
        const dateStr = date.format('YYYY-MM-DD');
        const availability = state.userProfile.availabilities.find(a => a.date === dateStr);
        return availability ? !availability.is_available : false;
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
            <Button onClick={() => navigate(-1)} sx={{ mb: 2 }}>{t('Common.Back')}</Button>
            
            {isOwner && (
                <Box sx={{ mb: 3, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => navigate(editPath)}
                    >
                        {t('Common.Edit')}
                    </Button>
                    <Button 
                        variant="contained" 
                        color="error" 
                        onClick={handleDelete}
                    >
                        {t('Common.Delete')}
                    </Button>
                </Box>
            )}

            <Grid container spacing={4}>
                {state.userProfile.is_recommended && (
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2, mb: 2, bgcolor: '#fffde7', border: '1px solid #ffd54f' }}>
                            <Typography variant="h6" gutterBottom color="warning.dark">
                                Admin: {t('Business.LinkToRegisteredProfile', 'Összekapcsolás regisztrált profillal')}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                                <Autocomplete
                                    fullWidth
                                    options={allCompanies}
                                    getOptionLabel={(option) => option.name || ""}
                                    value={allCompanies.find(c => c.id === linkCompanyId) || null}
                                    onChange={(event, newValue) => {
                                        setLinkCompanyId(newValue ? newValue.id : null);
                                    }}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            label={t('Business.SearchRegisteredMaster', 'Regisztrált szakember keresése')} 
                                            size="small"
                                        />
                                    )}
                                />
                                <Button 
                                    variant="contained" 
                                    onClick={handleLinkCompany}
                                    disabled={!linkCompanyId}
                                    startIcon={<LinkIcon />}
                                >
                                    {t('Business.LinkButton', 'Társítás')}
                                </Button>
                            </Box>
                        </Paper>
                    </Grid>
                )}

                <Grid item xs={12} md={5}>
                    <Card sx={{ p: 3, textAlign: 'center', bgcolor: '#f5f5f5', height: '100%' }}>
                        <Avatar 
                            src={state.userProfile.profilePic || defaultProfilePicture} 
                            sx={{ width: 150, height: 150, mx: 'auto', mb: 2, border: '3px solid #105b79' }}
                        />
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#105b79' }}>
                            {state.userProfile.companyName}
                        </Typography>

                        {state.userProfile.is_recommended && (
                            <Box sx={{ mt: 1, mb: 2 }}>
                                <Chip 
                                    label={t('Business.RecommendedStatus', 'Ajánlott szakember')} 
                                    color="secondary" 
                                    variant="outlined" 
                                    icon={<StarIcon />}
                                    sx={{ mb: 1 }}
                                />
                                {state.userProfile.recommender_name && (
                                    <Typography variant="body2" color="text.secondary">
                                        {t('Business.RecommendedBy', 'Ajánlotta')}: {state.userProfile.recommender_name}
                                    </Typography>
                                )}
                                {state.userProfile.linked_master_details && (
                                    <Button 
                                        startIcon={<PersonIcon />}
                                        onClick={() => navigate(`/ceg/${state.userProfile.linked_master_details.id}`)}
                                        sx={{ mt: 1, textTransform: 'none' }}
                                    >
                                        {t('Business.ViewRegisteredProfile', 'Regisztrált profil megtekintése')}
                                    </Button>
                                )}
                            </Box>
                        )}

                        <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
                            {state.userProfile.bio || t('Common.NoBio', 'Nincs leírás megadva.')}
                        </Typography>
                        
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2, textAlign: 'left' }}>
                            {state.userProfile.phoneNumber && (
                                <Typography variant="body2">
                                    <strong>{t('Administration.PhoneNumber')}:</strong> {state.userProfile.phoneNumber}
                                </Typography>
                            )}
                            {state.userProfile.email && (
                                <Typography variant="body2">
                                    <strong>Email:</strong> {state.userProfile.email}
                                </Typography>
                            )}
                            {state.userProfile.website && (
                                <Typography variant="body2">
                                    <strong>{t('Business.Website', 'Honlap')}:</strong> <a href={state.userProfile.website.startsWith('http') ? state.userProfile.website : `https://${state.userProfile.website}`} target="_blank" rel="noopener noreferrer">{state.userProfile.website}</a>
                                </Typography>
                            )}
                            {state.userProfile.szek && (
                                <Typography variant="body2">
                                    <strong>{t('Events.Szek')}:</strong> {state.userProfile.szek}
                                </Typography>
                            )}
                            {state.userProfile.kozsegvaros && (
                                <Typography variant="body2">
                                    <strong>{t('Events.Kozseg')}:</strong> {state.userProfile.kozsegvaros}
                                </Typography>
                            )}
                            {state.userProfile.telepules && (
                                <Typography variant="body2">
                                    <strong>{t('Events.Telepules')}:</strong> {state.userProfile.telepules}
                                </Typography>
                            )}
                            {state.userProfile.address && (
                                <Typography variant="body2">
                                    <strong>{t('Thematic.Address')}:</strong> {state.userProfile.address}
                                </Typography>
                            )}
                        </Box>

                        <Divider sx={{ my: 2 }} />
                        
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                            {whatsappUrl && (
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    startIcon={<WhatsAppIcon />}
                                    href={whatsappUrl}
                                    target="_blank"
                                >
                                    WhatsApp
                                </Button>
                            )}
                            {messengerUrl && (
                                <Button 
                                    variant="contained" 
                                    sx={{ bgcolor: '#0084FF', '&:hover': { bgcolor: '#0073e6' } }}
                                    startIcon={<ChatIcon />}
                                    href={messengerUrl}
                                    target="_blank"
                                >
                                    Messenger
                                </Button>
                            )}
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={12} md={7}>
                    <Card sx={{ p: 3 }}>
                        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
                            {t('Business.BookCompany', 'Cég/Mester foglalása')}
                        </Typography>
                        
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box sx={{ mb: 3 }}>
                                <StaticDatePicker
                                    displayStaticWrapperAs="desktop"
                                    value={selectedDate}
                                    onChange={(newValue) => setSelectedDate(newValue)}
                                    renderInput={(params) => <TextField {...params} />}
                                    minDate={dayjs()}
                                    shouldDisableDate={shouldDisableDate}
                                />
                            </Box>
                        </LocalizationProvider>

                        <Box sx={{ mt: 2, textAlign: 'right' }}>
                            <Typography variant="body2" sx={{ mb: 2 }}>
                                {t('Business.SelectedDate', 'Kiválasztott dátum')}: {selectedDate.format('YYYY-MM-DD')}
                            </Typography>
                            <Button 
                                variant="contained" 
                                size="large" 
                                onClick={handleBooking}
                                sx={{ bgcolor: '#105b79' }}
                            >
                                {t('Business.ConfirmBooking', 'Foglalás megerősítése')}
                            </Button>
                        </Box>
                    </Card>

                    {(state.userProfile.latitude && state.userProfile.longitude) && (
                        <Card sx={{ mt: 3, p: 2 }}>
                            <Typography variant="h6" gutterBottom>{t('Common.Location', 'Helyszín')}</Typography>
                            <Box sx={{ height: 300, width: '100%', borderRadius: 1, overflow: 'hidden' }}>
                                <MapContainer center={[state.userProfile.latitude, state.userProfile.longitude]} zoom={13} style={{ height: '100%', width: '100%' }}>
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <Marker position={[state.userProfile.latitude, state.userProfile.longitude]} icon={defaultIcon} />
                                </MapContainer>
                            </Box>
                            {state.userProfile.address && (
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    <strong>{t('Thematic.Address')}:</strong> {state.userProfile.address}
                                </Typography>
                            )}
                            {(state.userProfile.szek || state.userProfile.kozsegvaros || state.userProfile.telepules) && (
                                <Typography variant="body2" color="text.secondary">
                                    {[state.userProfile.szek, state.userProfile.kozsegvaros, state.userProfile.telepules].filter(Boolean).join(' - ')}
                                </Typography>
                            )}
                        </Card>
                    )}
                </Grid>
            </Grid>

            {state.userProfile.sellerListings.length > 0 && (
                <Box sx={{ mt: 5 }}>
                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
                        {t('Market.Listings', 'Hirdetések')}
                    </Typography>
                    <Grid container spacing={2}>
                        {state.userProfile.sellerListings.map((listing) => (
                            <Grid key={listing.id} item xs={12} sm={6} md={4}>
                                <Card sx={{ height: '100%' }}>
                                    <CardMedia
                                        sx={{ height: 140, cursor: 'pointer' }}
                                        image={listing.picture1 || defaultProfilePicture}
                                        title="Listing picture"
                                        onClick={() => navigate(`/terkep/${listing.id}`)} 
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h6" component="div">
                                            {listing.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {listing.description.substring(0, 100)}...
                                        </Typography>
                                    </CardContent>
                                    <CardActions>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                            {listing.price ? `$${listing.price.toLocaleString()}` : ''} 
                                            {listing.rental_frequency ? ` / ${listing.rental_frequency}` : ''}
                                        </Typography>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

            <Snackbar open={openSnack} autoHideDuration={6000} onClose={() => setOpenSnack(false)}>
                <Alert onClose={() => setOpenSnack(false)} severity={bookingStatus} sx={{ width: '100%' }}>
                    {bookingStatus === 'success' 
                        ? (t('Common.DeleteSuccess') ? t('Common.DeleteSuccess') : t('Business.BookingSuccess', 'Sikeres foglalás!'))
                        : (t('Common.DeleteError') ? t('Common.DeleteError') : t('Business.BookingError', 'Hiba történt a foglalás során.'))}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default CompanyDetail;
